// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-support-page {
  margin-top: 0 !important;
  font-family: "Open Sans", sans-serif !important;
  background: #101922;
  color: #ffffff;
  min-height: 100vh;
}
.faq-support-page .main-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.faq-support-page .header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}
.faq-support-page .theme-toggle-button {
  border-radius: 999px;
  padding: 2px;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.faq-support-page .theme-toggle-button:focus, .faq-support-page .theme-toggle-button:active, .faq-support-page .theme-toggle-button:focus-visible {
  border: none;
  outline: none;
  box-shadow: none;
}
.faq-support-page .theme-toggle-button:hover {
  background: transparent;
}
.faq-support-page .theme-toggle-track {
  width: 48px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  border: none;
  display: inline-flex;
  align-items: center;
  padding: 1px;
  transition: background-color 0.2s ease;
}
.faq-support-page .theme-toggle-track.active {
  background: #1f2937;
}
.faq-support-page .theme-toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
}
.faq-support-page .theme-toggle-track.active .theme-toggle-thumb {
  transform: translateX(22px);
  color: #ffffff;
  background: #0f172a;
}
.faq-support-page .theme-toggle-thumb mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.faq-support-page .theme-toggle-track.active .theme-toggle-thumb mat-icon {
  color: #ffffff !important;
}
.faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #6b7280 !important;
}
.faq-support-page .page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  margin-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(10, 12, 16, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.faq-support-page .page-header ~ :global(.flow-sidebar) {
  z-index: 1001 !important;
}
.faq-support-page .page-header.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  background: rgba(10, 12, 16, 0.98);
}
.faq-support-page .page-header .header-container {
  max-width: 100%;
  width: 100%;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 768px) {
  .faq-support-page .page-header .header-container {
    padding: 0 16px;
    gap: 16px;
    height: 56px;
  }
}
.faq-support-page .page-header .header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  margin-right: 0;
}
.faq-support-page .page-header .menu-button {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.faq-support-page .page-header .menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.faq-support-page .page-header .menu-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.faq-support-page .page-header .header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.faq-support-page .page-header .header-logo img {
  height: 45px;
  width: auto;
  display: block;
}
.faq-support-page .page-header .header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .faq-support-page .page-header .header-nav {
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .faq-support-page .page-header .header-nav {
    display: none;
  }
}
.faq-support-page .page-header .header-nav .nav-link {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  padding: 4px 0;
}
.faq-support-page .page-header .header-nav .nav-link:hover {
  color: #ffffff;
}
.faq-support-page .page-header .btn-get-started {
  background: #ffffff;
  color: #000000;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-left: 0;
}
.faq-support-page .page-header .btn-get-started:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
  .faq-support-page .page-header .btn-get-started {
    padding: 8px 16px;
    font-size: 12px;
  }
}
.faq-support-page .breadcrumb {
  margin-top: 64px;
}
@media (max-width: 768px) {
  .faq-support-page .breadcrumb {
    margin-top: 56px;
  }
}
.faq-support-page .main-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.faq-support-page .page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  margin-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(10, 12, 16, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.faq-support-page .page-header ~ :global(.flow-sidebar) {
  z-index: 1001 !important;
}
.faq-support-page .page-header.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  background: rgba(10, 12, 16, 0.98);
}
.faq-support-page .page-header .header-container {
  max-width: 100%;
  width: 100%;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 768px) {
  .faq-support-page .page-header .header-container {
    padding: 0 16px;
    gap: 16px;
    height: 56px;
  }
}
.faq-support-page .page-header .header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  margin-right: 0;
}
.faq-support-page .page-header .menu-button {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.faq-support-page .page-header .menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.faq-support-page .page-header .menu-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.faq-support-page .page-header .header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.faq-support-page .page-header .header-logo img {
  height: 45px;
  width: auto;
  display: block;
}
.faq-support-page .page-header .header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .faq-support-page .page-header .header-nav {
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .faq-support-page .page-header .header-nav {
    display: none;
  }
}
.faq-support-page .page-header .header-nav .nav-link {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  padding: 4px 0;
}
.faq-support-page .page-header .header-nav .nav-link:hover {
  color: #ffffff;
}
.faq-support-page .page-header .btn-get-started {
  background: #ffffff;
  color: #000000;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-left: 0;
}
.faq-support-page .page-header .btn-get-started:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
  .faq-support-page .page-header .btn-get-started {
    padding: 8px 16px;
    font-size: 12px;
  }
}
.faq-support-page .breadcrumb {
  margin-top: 64px;
  padding-top: 16px;
}
@media (max-width: 768px) {
  .faq-support-page .breadcrumb {
    margin-top: 56px;
  }
}
.faq-support-page .breadcrumb {
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 0;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  background: transparent;
}
.faq-support-page .breadcrumb a {
  color: #ffffff !important;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}
.faq-support-page .breadcrumb a:hover {
  color: #5ea1d8 !important;
}
.faq-support-page .breadcrumb span:last-child {
  color: #ffffff !important;
  font-weight: 600;
}
.faq-support-page .breadcrumb .separator {
  color: #94a3b8;
  font-weight: 500;
}
@media (max-width: 768px) {
  .faq-support-page .breadcrumb {
    padding: 8px 16px;
    font-size: 13px;
  }
}
.faq-support-page .faq-container {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 16px 80px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 768px) {
  .faq-support-page .faq-container {
    padding: 20px 16px 60px;
    gap: 20px;
  }
}
.faq-support-page .faq-header {
  text-align: center;
  margin-bottom: 0;
  padding: 40px 0 60px;
  background: linear-gradient(to bottom, transparent, rgba(94, 161, 216, 0.05));
  border-radius: 12px;
  border: 1px solid rgba(94, 161, 216, 0.1);
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}
@media (max-width: 768px) {
  .faq-support-page .faq-header {
    padding: 30px 16px 50px;
    margin-bottom: 0;
  }
}
.faq-support-page .faq-header .faq-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #ffffff !important;
  letter-spacing: -0.025em;
  font-family: "Open Sans", sans-serif;
  padding: 0 16px;
  line-height: 1.25;
}
@media (max-width: 768px) {
  .faq-support-page .faq-header .faq-title {
    font-size: 36px;
    margin-bottom: 12px;
  }
}
.faq-support-page .faq-header .faq-subtitle {
  font-size: 18px;
  color: #ffffff !important;
  margin-bottom: 0;
  line-height: 1.6;
  max-width: 672px;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding: 0 24px;
}
@media (max-width: 768px) {
  .faq-support-page .faq-header .faq-subtitle {
    font-size: 16px;
    padding: 0 20px;
  }
}
.faq-support-page .faq-header .search-container {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 672px;
  width: calc(100% - 32px);
  margin: 0 auto;
  z-index: 2;
  padding: 0 16px;
}
.faq-support-page .faq-header .search-container .search-wrapper {
  background: #1c2631;
  border-radius: 12px;
  border: 1px solid #334155;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 4px;
}
.faq-support-page .faq-header .search-container .search-label {
  display: flex;
  align-items: center;
  height: 56px;
  width: 100%;
  cursor: text;
}
.faq-support-page .faq-header .search-container .search-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  color: #94a3b8;
}
.faq-support-page .faq-header .search-container .search-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  pointer-events: none;
}
.faq-support-page .faq-header .search-container .search-input {
  flex: 1;
  min-width: 0;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  color: #ffffff !important;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding-left: 16px;
  padding-right: 16px;
}
.faq-support-page .faq-header .search-container .search-input::placeholder {
  color: #94a3b8;
}
.faq-support-page .faq-header .search-container .search-input:focus {
  outline: none;
}
.faq-support-page .category-tabs {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 32px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 16px;
  overflow-x: auto;
}
@media (max-width: 768px) {
  .faq-support-page .category-tabs {
    gap: 20px;
    justify-content: flex-start;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .faq-support-page .category-tabs::-webkit-scrollbar {
    display: none;
  }
}
.faq-support-page .category-tabs .category-tab {
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 700;
  padding: 16px 8px 13px;
  cursor: pointer;
  transition: color 0.3s ease;
  font-family: "Open Sans", sans-serif;
  position: relative;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.025em;
  line-height: 1.5;
  -webkit-tap-highlight-color: transparent;
}
@media (max-width: 768px) {
  .faq-support-page .category-tabs .category-tab {
    font-size: 16px;
    padding: 16px 8px 13px;
  }
}
.faq-support-page .category-tabs .category-tab:hover {
  color: #5ea1d8 !important;
}
.faq-support-page .category-tabs .category-tab:focus, .faq-support-page .category-tabs .category-tab:active, .faq-support-page .category-tabs .category-tab:focus-visible {
  border: none;
  outline: none;
  box-shadow: none;
}
.faq-support-page .category-tabs .category-tab.active {
  color: #5ea1d8 !important;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
}
.faq-support-page .faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}
.faq-support-page .faq-accordion .faq-item {
  background: #1c2631;
  border: 1px solid #334155;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}
.faq-support-page .faq-accordion .faq-item:hover {
  border-color: rgba(94, 161, 216, 0.5);
}
.faq-support-page .faq-accordion .faq-item .faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
}
@media (max-width: 768px) {
  .faq-support-page .faq-accordion .faq-item .faq-question {
    padding: 20px;
  }
}
.faq-support-page .faq-accordion .faq-item .faq-question .faq-question-text {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff !important;
  flex: 1;
  text-align: left;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .faq-support-page .faq-accordion .faq-item .faq-question .faq-question-text {
    font-size: 16px;
  }
}
.faq-support-page .faq-accordion .faq-item .faq-question .faq-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  margin-left: 16px;
}
.faq-support-page .faq-accordion .faq-item.open .faq-icon {
  color: #5ea1d8;
}
.faq-support-page .faq-accordion .faq-item:not(.open) .faq-icon {
  color: #94a3b8;
}
.faq-support-page .faq-accordion .faq-item:not(.open):hover .faq-icon {
  color: #5ea1d8;
}
.faq-support-page .faq-accordion .faq-item .faq-answer {
  padding: 0 24px 24px;
  color: #ffffff !important;
  font-size: 18px;
  line-height: 1.75;
  animation: fadeIn 0.3s ease;
  border-top: 1px solid #1e293b;
  padding-top: 16px;
  margin-top: 0;
  text-align: left;
}
@media (max-width: 768px) {
  .faq-support-page .faq-accordion .faq-item .faq-answer {
    padding: 0 20px 20px;
    padding-top: 16px;
    font-size: 17px;
  }
}
.faq-support-page .faq-accordion .faq-item .faq-answer p {
  margin: 0;
  color: #ffffff !important;
  font-size: 18px;
  text-align: left;
}
@media (max-width: 768px) {
  .faq-support-page .faq-accordion .faq-item .faq-answer p {
    font-size: 17px;
  }
}
.faq-support-page .support-cta {
  background: linear-gradient(to right, #5ea1d8, #5ea1d8);
  border-radius: 16px;
  padding: 32px;
  margin-top: 48px;
  margin-bottom: 40px;
  box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.2);
}
@media (max-width: 768px) {
  .faq-support-page .support-cta {
    padding: 24px;
    margin-top: 40px;
  }
}
.faq-support-page .support-cta .cta-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
  gap: 24px;
}
@media (max-width: 768px) {
  .faq-support-page .support-cta .cta-content {
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
  }
}
.faq-support-page .support-cta .cta-content .cta-text-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.faq-support-page .support-cta .cta-content .cta-text-section .cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  font-family: "Open Sans", sans-serif;
}
@media (max-width: 768px) {
  .faq-support-page .support-cta .cta-content .cta-text-section .cta-heading {
    font-size: 20px;
  }
}
.faq-support-page .support-cta .cta-content .cta-text-section .cta-text {
  font-size: 16px;
  color: rgba(191, 219, 254, 0.9);
  margin: 0;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .faq-support-page .support-cta .cta-content .cta-text-section .cta-text {
    font-size: 15px;
  }
}
.faq-support-page .support-cta .cta-content .cta-button {
  background: #ffffff;
  color: #5ea1d8;
  border: none;
  padding: 12px 32px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Open Sans", sans-serif;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .faq-support-page .support-cta .cta-content .cta-button {
    width: 100%;
    max-width: none;
  }
}
.faq-support-page .support-cta .cta-content .cta-button:hover {
  background: #eff6ff;
}
.faq-support-page .resources-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 64px;
}
@media (max-width: 968px) {
  .faq-support-page .resources-section {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .faq-support-page .resources-section {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
.faq-support-page .resources-section .resource-card {
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 24px;
  text-align: left;
  transition: all 0.3s ease;
  cursor: pointer;
}
@media (max-width: 768px) {
  .faq-support-page .resources-section .resource-card {
    padding: 20px;
  }
}
.faq-support-page .resources-section .resource-card:hover {
  border-color: #334155;
}
.faq-support-page .resources-section .resource-card .resource-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  background: rgba(94, 161, 216, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.faq-support-page .resources-section .resource-card .resource-icon mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.faq-support-page .resources-section .resource-card .resource-title {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff !important;
  margin-bottom: 8px;
  font-family: "Open Sans", sans-serif;
}
@media (max-width: 768px) {
  .faq-support-page .resources-section .resource-card .resource-title {
    font-size: 15px;
  }
}
.faq-support-page .resources-section .resource-card .resource-description {
  font-size: 14px;
  color: #ffffff !important;
  line-height: 1.5;
  margin: 0;
}
@media (max-width: 768px) {
  .faq-support-page .resources-section .resource-card .resource-description {
    font-size: 13px;
  }
}
.faq-support-page .footer {
  background: #000000;
  color: #ffffff;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.faq-support-page .footer .copy-rights {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}
.faq-support-page .footer .copy-rights .row {
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .faq-support-page .footer .copy-rights .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
.faq-support-page .footer .copy-rights .col-md-5,
.faq-support-page .footer .copy-rights .col-md-7,
.faq-support-page .footer .copy-rights .col-12 {
  padding: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .faq-support-page .footer .copy-rights .col-md-5,
  .faq-support-page .footer .copy-rights .col-md-7,
  .faq-support-page .footer .copy-rights .col-12 {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .faq-support-page .footer .copy-rights .col-md-5 {
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .faq-support-page .footer .copy-rights .col-md-7 {
    justify-content: flex-end;
  }
}
.faq-support-page .footer .cpyrgt {
  color: #64748b !important;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
}
@media (max-width: 768px) {
  .faq-support-page .footer .cpyrgt {
    flex-wrap: wrap;
  }
}
.faq-support-page .footer .cpyrgt li {
  color: #64748b !important;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.faq-support-page .footer .cpyrgt li a {
  color: #64748b !important;
  text-decoration: none;
  margin-left: 4px;
}
.faq-support-page .footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}
.faq-support-page .footer .f-menu-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .faq-support-page .footer .f-menu-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
.faq-support-page .footer .f-menu-right li {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.faq-support-page .footer .f-menu-right li:not(:last-child)::after {
  content: "|";
  color: rgba(100, 116, 139, 0.5);
  margin: 0 12px;
  font-size: 14px;
}
.faq-support-page .footer .f-menu-right li a {
  color: #64748b !important;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 4px 0;
  white-space: nowrap;
}
.faq-support-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
.faq-support-page .footer h6 {
  color: #94a3b8 !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  margin-bottom: 16px !important;
}
.faq-support-page .footer ul li a {
  color: #64748b !important;
  font-size: 14px !important;
}
.faq-support-page .footer ul li a:hover {
  color: #5ea1d8 !important;
}
.faq-support-page .footer p {
  color: #475569 !important;
  font-size: 14px !important;
}
.faq-support-page .footer .material-symbols-outlined {
  color: #475569 !important;
}
.faq-support-page .footer .material-symbols-outlined:hover {
  color: #ffffff !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:host-context(body.theme-light) .faq-support-page {
  background: #f8fafc !important;
  color: #1e293b !important;
}

:host-context(body.theme-light) .faq-support-page .page-header {
  background: rgba(255, 255, 255, 0.97) !important;
  border-bottom: 1px solid rgba(15, 23, 42, 0.09) !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08) !important;
}

:host-context(body.theme-light) .faq-support-page .page-header.scrolled {
  background: rgb(255, 255, 255) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .menu-button {
  color: #1e293b !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .menu-button:hover {
  background-color: rgba(15, 23, 42, 0.07) !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .header-nav .nav-link {
  color: #475569 !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .header-nav .nav-link:hover {
  color: #1e293b !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .btn-get-started {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}

:host-context(body.theme-light) .faq-support-page .page-header .btn-get-started:hover {
  background: #3b8ec7 !important;
}

:host-context(body.theme-light) .faq-support-page .breadcrumb a {
  color: #334155 !important;
}

:host-context(body.theme-light) .faq-support-page .breadcrumb a:hover {
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .breadcrumb span:last-child {
  color: #0f172a !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header {
  background: linear-gradient(135deg, #1a5f94 0%, #2472a4 40%, #3b8ec7 100%) !important;
  border: none !important;
  box-shadow: 0 4px 24px rgba(26, 95, 148, 0.25) !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .faq-title {
  color: #ffffff !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .faq-subtitle {
  color: rgba(255, 255, 255, 0.88) !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-wrapper {
  background: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 12px 32px rgba(26, 95, 148, 0.3) !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-icon-wrapper {
  color: #2472a4 !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-input {
  color: #0f172a !important;
}

:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-input::placeholder {
  color: #94a3b8 !important;
}

:host-context(body.theme-light) .faq-support-page .category-tabs {
  border-bottom: 1px solid #cbd5e1 !important;
}

:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab {
  color: #64748b !important;
}

:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab:hover {
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab.active {
  color: #5ea1d8 !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05) !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item:hover {
  border-color: rgba(94, 161, 216, 0.45) !important;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.1) !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-question .faq-question-text {
  color: #1e293b !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item:not(.open) .faq-icon {
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item.open .faq-icon {
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-answer {
  color: #334155 !important;
  border-top: 1px solid #f1f5f9 !important;
}

:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-answer p {
  color: #334155 !important;
}

:host-context(body.theme-light) .faq-support-page .support-cta {
  background: linear-gradient(to right, #5ea1d8, #3b8ec7) !important;
  box-shadow: 0 16px 32px -8px rgba(94, 161, 216, 0.3) !important;
}

:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-text-section .cta-heading {
  color: #ffffff !important;
}

:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-text-section .cta-text {
  color: rgba(219, 234, 254, 0.95) !important;
}

:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-button {
  background: #ffffff !important;
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-button:hover {
  background: #eff6ff !important;
}

:host-context(body.theme-light) .faq-support-page .resources-section .resource-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

:host-context(body.theme-light) .faq-support-page .resources-section .resource-card:hover {
  border-color: #5ea1d8 !important;
  box-shadow: 0 4px 16px rgba(94, 161, 216, 0.15) !important;
}

:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-icon {
  background: rgba(94, 161, 216, 0.12) !important;
}

:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-title {
  color: #0f172a !important;
}

:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-description {
  color: #64748b !important;
}

:host-context(body.theme-light) .faq-support-page .footer {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-top: 1px solid #e2e8f0 !important;
}

:host-context(body.theme-light) .faq-support-page .footer .cpyrgt,
:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li {
  color: #64748b !important;
}

:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li a,
:host-context(body.theme-light) .faq-support-page .footer .f-menu-right li a {
  color: #64748b !important;
}

:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li a:hover,
:host-context(body.theme-light) .faq-support-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}

:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) {
  background: #e5e7eb !important;
}

:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb {
  background: #ffffff !important;
}

:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #5ea1d8 !important;
}

body.theme-light-DISABLED .faq-support-page {
  background: #f8fafc;
  color: #0f172a;
}
body.theme-light-DISABLED .faq-support-page .page-header {
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid rgba(15, 23, 42, 0.09);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}
body.theme-light-DISABLED .faq-support-page .page-header.scrolled {
  background: rgb(255, 255, 255);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
body.theme-light-DISABLED .faq-support-page .page-header .menu-button {
  color: #1e293b;
}
body.theme-light-DISABLED .faq-support-page .page-header .menu-button:hover {
  background-color: rgba(15, 23, 42, 0.07);
}
body.theme-light-DISABLED .faq-support-page .page-header .header-nav .nav-link {
  color: rgba(15, 23, 42, 0.5);
}
body.theme-light-DISABLED .faq-support-page .page-header .header-nav .nav-link:hover {
  color: #0f172a;
}
body.theme-light-DISABLED .faq-support-page .page-header .btn-get-started {
  background: #0f172a;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
}
body.theme-light-DISABLED .faq-support-page .page-header .btn-get-started:hover {
  background: #1e293b;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.22);
}
body.theme-light-DISABLED .faq-support-page .breadcrumb a {
  color: #334155 !important;
}
body.theme-light-DISABLED .faq-support-page .breadcrumb a:hover {
  color: #5ea1d8 !important;
}
body.theme-light-DISABLED .faq-support-page .breadcrumb span:last-child {
  color: #0f172a !important;
}
body.theme-light-DISABLED .faq-support-page .breadcrumb .separator {
  color: #94a3b8;
}
body.theme-light-DISABLED .faq-support-page .faq-header {
  background: linear-gradient(to bottom, #eef5fb, rgba(219, 234, 254, 0.35));
  border: 1px solid rgba(94, 161, 216, 0.2);
}
body.theme-light-DISABLED .faq-support-page .faq-header .faq-title {
  color: #0f172a !important;
}
body.theme-light-DISABLED .faq-support-page .faq-header .faq-subtitle {
  color: #475569 !important;
}
body.theme-light-DISABLED .faq-support-page .faq-header .search-container .search-wrapper {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  box-shadow: 0 8px 24px -6px rgba(15, 23, 42, 0.12);
}
body.theme-light-DISABLED .faq-support-page .faq-header .search-container .search-icon-wrapper {
  color: #64748b;
}
body.theme-light-DISABLED .faq-support-page .faq-header .search-container .search-input {
  color: #0f172a !important;
}
body.theme-light-DISABLED .faq-support-page .faq-header .search-container .search-input::placeholder {
  color: #94a3b8;
}
body.theme-light-DISABLED .faq-support-page .category-tabs {
  border-bottom: 1px solid #cbd5e1;
}
body.theme-light-DISABLED .faq-support-page .category-tabs .category-tab {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .category-tabs .category-tab:hover {
  color: #1e293b !important;
}
body.theme-light-DISABLED .faq-support-page .category-tabs .category-tab.active {
  color: #5ea1d8 !important;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item:hover {
  border-color: rgba(94, 161, 216, 0.45);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.1);
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item .faq-question {
  background: transparent;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item .faq-question .faq-question-text {
  color: #0f172a !important;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item:not(.open) .faq-icon {
  color: #94a3b8;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item:not(.open):hover .faq-icon {
  color: #5ea1d8;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item.open .faq-icon {
  color: #5ea1d8;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item .faq-answer {
  color: #475569 !important;
  border-top: 1px solid #f1f5f9;
}
body.theme-light-DISABLED .faq-support-page .faq-accordion .faq-item .faq-answer p {
  color: #475569 !important;
}
body.theme-light-DISABLED .faq-support-page .support-cta {
  background: linear-gradient(to right, #5ea1d8, #3b8ec7);
  box-shadow: 0 16px 32px -8px rgba(94, 161, 216, 0.35);
}
body.theme-light-DISABLED .faq-support-page .support-cta .cta-heading {
  color: #ffffff;
}
body.theme-light-DISABLED .faq-support-page .support-cta .cta-text {
  color: rgba(219, 234, 254, 0.95);
}
body.theme-light-DISABLED .faq-support-page .support-cta .cta-button {
  background: #ffffff;
  color: #5ea1d8;
}
body.theme-light-DISABLED .faq-support-page .support-cta .cta-button:hover {
  background: #eff6ff;
}
body.theme-light-DISABLED .faq-support-page .resources-section .resource-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}
body.theme-light-DISABLED .faq-support-page .resources-section .resource-card:hover {
  border-color: #bfdbfe;
  box-shadow: 0 4px 16px rgba(94, 161, 216, 0.12);
}
body.theme-light-DISABLED .faq-support-page .resources-section .resource-card .resource-icon {
  background: rgba(94, 161, 216, 0.12);
}
body.theme-light-DISABLED .faq-support-page .resources-section .resource-card .resource-title {
  color: #0f172a !important;
}
body.theme-light-DISABLED .faq-support-page .resources-section .resource-card .resource-description {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer {
  background: #f1f5f9;
  color: #475569;
  border-top: 1px solid #e2e8f0;
}
body.theme-light-DISABLED .faq-support-page .footer .cpyrgt,
body.theme-light-DISABLED .faq-support-page .footer .cpyrgt li {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer .cpyrgt li a {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
}
body.theme-light-DISABLED .faq-support-page .footer .f-menu-right li::after {
  color: rgba(100, 116, 139, 0.4) !important;
}
body.theme-light-DISABLED .faq-support-page .footer .f-menu-right li a {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
body.theme-light-DISABLED .faq-support-page .footer h6 {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer p {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer .material-symbols-outlined {
  color: #64748b !important;
}
body.theme-light-DISABLED .faq-support-page .footer .material-symbols-outlined:hover {
  color: #5ea1d8 !important;
}
body.theme-light-DISABLED .faq-support-page .theme-toggle-track {
  background: #e5e7eb;
}
body.theme-light-DISABLED .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb {
  background: #ffffff;
  color: #6b7280;
}
body.theme-light-DISABLED .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #6b7280 !important;
}

@media screen and (max-width: 992px) {
  :host footer,
  :host .footer,
  app-faq-support-page footer,
  app-faq-support-page .footer {
    display: block !important;
    visibility: visible !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/faq-support-page/faq-support-page.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EAuPA,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AArPF;AAHE;EACE,wBAAA;EACA,yBAAA;AAKJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAIJ;AADE;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAGJ;AADI;EAGE,YAAA;EACA,aAAA;EACA,gBAAA;AACN;AAEI;EACE,uBAAA;AAAN;AAIE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4EAAA;AAJJ;AAOE;EACE,2BAAA;EACA,cAAA;EACA,mBAAA;AALJ;AAQE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AANJ;AASE;EACE,yBAAA;AAPJ;AAUE;EACE,yBAAA;AARJ;AAYE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,wBAAA;EACA,kDAAA;EACA,kCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;EACA,wCAAA;AAVJ;AAaI;EACE,wBAAA;AAXN;AAcI;EACE,yCAAA;EACA,kCAAA;AAZN;AAeI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAbN;AAeM;EAVF;IAWI,eAAA;IACA,SAAA;IACA,YAAA;EAZN;AACF;AAeI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAbN;AAgBI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;AAdN;AAgBM;EACE,0CAAA;AAdR;AAiBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfR;AAmBI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAjBN;AAmBM;EACE,YAAA;EACA,WAAA;EACA,cAAA;AAjBR;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAnBN;AAqBM;EATF;IAUI,SAAA;EAlBN;AACF;AAoBM;EAbF;IAcI,aAAA;EAjBN;AACF;AAmBM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAjBR;AAmBQ;EACE,cAAA;AAjBV;AAsBI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,cAAA;AApBN;AAsBM;EACE,qCAAA;EACA,2BAAA;EACA,yCAAA;AApBR;AAuBM;EArBF;IAsBI,iBAAA;IACA,eAAA;EApBN;AACF;AAyBE;EACE,gBAAA;AAvBJ;AAyBI;EAHF;IAII,gBAAA;EAtBJ;AACF;AA+BE;EACE,wBAAA;EACA,yBAAA;AA7BJ;AAiCE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,wBAAA;EACA,kDAAA;EACA,kCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;EACA,wCAAA;AA/BJ;AAkCI;EACE,wBAAA;AAhCN;AAmCI;EACE,yCAAA;EACA,kCAAA;AAjCN;AAoCI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAlCN;AAoCM;EAVF;IAWI,eAAA;IACA,SAAA;IACA,YAAA;EAjCN;AACF;AAoCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAlCN;AAqCI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;AAnCN;AAqCM;EACE,0CAAA;AAnCR;AAsCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApCR;AAwCI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAtCN;AAwCM;EACE,YAAA;EACA,WAAA;EACA,cAAA;AAtCR;AA0CI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAxCN;AA0CM;EATF;IAUI,SAAA;EAvCN;AACF;AAyCM;EAbF;IAcI,aAAA;EAtCN;AACF;AAwCM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAtCR;AAwCQ;EACE,cAAA;AAtCV;AA2CI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,cAAA;AAzCN;AA2CM;EACE,qCAAA;EACA,2BAAA;EACA,yCAAA;AAzCR;AA4CM;EArBF;IAsBI,iBAAA;IACA,eAAA;EAzCN;AACF;AA8CE;EACE,gBAAA;EACA,iBAAA;AA5CJ;AA8CI;EAJF;IAKI,gBAAA;EA3CJ;AACF;AA+CE;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;AA7CJ;AA+CI;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;AA7CN;AA+CM;EACE,yBAAA;AA7CR;AAiDI;EACE,yBAAA;EACA,gBAAA;AA/CN;AAkDI;EACE,cAAA;EACA,gBAAA;AAhDN;AAmDI;EAhCF;IAiCI,iBAAA;IACA,eAAA;EAhDJ;AACF;AAoDE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlDJ;AAoDI;EARF;IASI,uBAAA;IACA,SAAA;EAjDJ;AACF;AAqDE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,6EAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAnDJ;AAqDI;EAXF;IAYI,uBAAA;IACA,gBAAA;EAlDJ;AACF;AAoDI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AAlDN;AAoDM;EAVF;IAWI,eAAA;IACA,mBAAA;EAjDN;AACF;AAoDI;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAlDN;AAoDM;EAXF;IAYI,eAAA;IACA,eAAA;EAjDN;AACF;AAqDI;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AAnDN;AAqDM;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;EACA,YAAA;AAnDR;AAsDM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AApDR;AAuDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AArDR;AAwDM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAtDR;AAyDM;EACE,OAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvDR;AAyDQ;EACE,cAAA;AAvDV;AA0DQ;EACE,aAAA;AAxDV;AA+DE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AA7DJ;AA+DI;EAVF;IAWI,SAAA;IACA,2BAAA;IACA,iCAAA;IACA,qBAAA;EA5DJ;EA8DI;IACE,aAAA;EA5DN;AACF;AA+DI;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wCAAA;AA7DN;AA+DM;EAtBF;IAuBI,eAAA;IACA,sBAAA;EA5DN;AACF;AA8DM;EACE,yBAAA;AA5DR;AA+DM;EAGE,YAAA;EACA,aAAA;EACA,gBAAA;AA/DR;AAkEM;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAhER;AAsEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AApEJ;AAsEI;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AApEN;AAsEM;EACE,qCAAA;AApER;AAuEM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AArER;AAuEQ;EAZF;IAaI,aAAA;EApER;AACF;AAsEQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;AApEV;AAsEU;EARF;IASI,eAAA;EAnEV;AACF;AAsEQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AApEV;AAyEQ;EACE,cAAA;AAvEV;AA4EQ;EACE,cAAA;AA1EV;AA6EQ;EACE,cAAA;AA3EV;AA+EM;EACE,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AA7ER;AA+EQ;EAXF;IAYI,oBAAA;IACA,iBAAA;IACA,eAAA;EA5ER;AACF;AA8EQ;EACE,SAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA5EV;AA8EU;EANF;IAOI,eAAA;EA3EV;AACF;AAkFE;EACE,uDAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,oDAAA;AAhFJ;AAkFI;EARF;IASI,aAAA;IACA,gBAAA;EA/EJ;AACF;AAiFI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA/EN;AAiFM;EAPF;IAQI,sBAAA;IACA,SAAA;IACA,uBAAA;EA9EN;AACF;AAgFM;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA9ER;AAgFQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,oCAAA;AA9EV;AAgFU;EAPF;IAQI,eAAA;EA7EV;AACF;AAgFQ;EACE,eAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;AA9EV;AAgFU;EANF;IAOI,eAAA;EA7EV;AACF;AAiFM;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;AA/ER;AAiFQ;EAbF;IAcI,WAAA;IACA,eAAA;EA9ER;AACF;AAgFQ;EACE,mBAAA;AA9EV;AAqFE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAnFJ;AAqFI;EANF;IAOI,qCAAA;EAlFJ;AACF;AAoFI;EAVF;IAWI,0BAAA;IACA,SAAA;EAjFJ;AACF;AAmFI;EACE,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAjFN;AAmFM;EATF;IAUI,aAAA;EAhFN;AACF;AAkFM;EACE,qBAAA;AAhFR;AAmFM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjFR;AAmFQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAjFV;AAqFM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AAnFR;AAqFQ;EAPF;IAQI,eAAA;EAlFR;AACF;AAqFM;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAnFR;AAqFQ;EANF;IAOI,eAAA;EAlFR;AACF;AAyFE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;AAvFJ;AAyFI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAvFN;AAyFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAvFR;AAyFQ;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;EAtFR;AACF;AAyFM;;;EAGE,UAAA;EACA,aAAA;EACA,mBAAA;AAvFR;AAyFQ;EAPF;;;IAQI,WAAA;IACA,2BAAA;EApFR;AACF;AAwFQ;EADF;IAEI,2BAAA;EArFR;AACF;AAyFQ;EADF;IAEI,yBAAA;EAtFR;AACF;AA0FI;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAxFN;AA0FM;EAXF;IAYI,eAAA;EAvFN;AACF;AAyFM;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAvFR;AAyFQ;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AAvFV;AAyFU;EACE,yBAAA;EACA,0BAAA;AAvFZ;AA6FI;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AA3FN;AA6FM;EAXF;IAYI,2BAAA;IACA,eAAA;EA1FN;AACF;AA4FM;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA1FR;AA4FQ;EACE,YAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;AA1FV;AA6FQ;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AA3FV;AA6FU;EACE,yBAAA;AA3FZ;AAiGI;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;AA/FN;AAoGQ;EACE,yBAAA;EACA,0BAAA;AAlGV;AAoGU;EACE,yBAAA;AAlGZ;AAwGI;EACE,yBAAA;EACA,0BAAA;AAtGN;AAyGI;EACE,yBAAA;AAvGN;AAyGM;EACE,yBAAA;AAvGR;;AA8GA;EACE;IACE,UAAA;IACA,4BAAA;EA3GF;EA6GA;IACE,UAAA;IACA,wBAAA;EA3GF;AACF;AAoHA;EACE,8BAAA;EACA,yBAAA;AAlHF;;AAuHA;EACE,gDAAA;EACA,0DAAA;EACA,oDAAA;AApHF;;AAsHA;EACE,yCAAA;EACA,oDAAA;AAnHF;;AAqHA;EACE,yBAAA;AAlHF;;AAoHA;EACE,mDAAA;AAjHF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,yBAAA;AAhHF;;AAkHA;EACE,8BAAA;EACA,yBAAA;AA/GF;;AAiHA;EACE,8BAAA;AA9GF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,yBAAA;AAhHF;;AAkHA;EACE,yBAAA;AA/GF;;AAoHA;EACE,qFAAA;EACA,uBAAA;EACA,yDAAA;AAjHF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,2CAAA;AAhHF;;AAsHA;EACE,8BAAA;EACA,qDAAA;EACA,yDAAA;AAnHF;;AAqHA;EACE,yBAAA;AAlHF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,yBAAA;AAhHF;;AAsHA;EACE,2CAAA;AAnHF;;AAqHA;EACE,yBAAA;AAlHF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,kCAAA;AAhHF;;AAwHA;EACE,8BAAA;EACA,oCAAA;EACA,uDAAA;AArHF;;AAuHA;EACE,iDAAA;EACA,yDAAA;AApHF;;AAsHA;EACE,yBAAA;AAnHF;;AAqHA;EACE,yBAAA;AAlHF;;AAoHA;EACE,yBAAA;AAjHF;;AAmHA;EACE,yBAAA;EACA,wCAAA;AAhHF;;AAkHA;EACE,yBAAA;AA/GF;;AAmHA;EACE,kEAAA;EACA,+DAAA;AAhHF;;AAkHA;EACE,yBAAA;AA/GF;;AAiHA;EACE,2CAAA;AA9GF;;AAgHA;EACE,8BAAA;EACA,yBAAA;AA7GF;;AA+GA;EACE,8BAAA;AA5GF;;AAkHA;EACE,8BAAA;EACA,oCAAA;AA/GF;;AAiHA;EACE,gCAAA;EACA,0DAAA;AA9GF;;AAgHA;EACE,+CAAA;AA7GF;;AA+GA;EACE,yBAAA;AA5GF;;AA8GA;EACE,yBAAA;AA3GF;;AA+GA;EACE,8BAAA;EACA,yBAAA;EACA,wCAAA;AA5GF;;AA8GA;;EAEE,yBAAA;AA3GF;;AA6GA;;EAEE,yBAAA;AA1GF;;AA4GA;;EAEE,yBAAA;AAzGF;;AA6GA;EACE,8BAAA;AA1GF;;AA4GA;EACE,8BAAA;AAzGF;;AA2GA;EACE,yBAAA;AAxGF;;AA6GE;EACE,mBAAA;EACA,cAAA;AA1GJ;AA6GI;EACE,qCAAA;EACA,+CAAA;EACA,yCAAA;AA3GN;AA6GM;EACE,8BAAA;EACA,yCAAA;AA3GR;AA8GM;EACE,cAAA;AA5GR;AA8GQ;EACE,wCAAA;AA5GV;AAgHM;EACE,4BAAA;AA9GR;AAgHQ;EACE,cAAA;AA9GV;AAkHM;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAhHR;AAkHQ;EACE,mBAAA;EACA,6CAAA;AAhHV;AAuHM;EACE,yBAAA;AArHR;AAuHQ;EACE,yBAAA;AArHV;AAyHM;EACE,yBAAA;AAvHR;AA0HM;EACE,cAAA;AAxHR;AA6HI;EACE,0EAAA;EACA,yCAAA;AA3HN;AA6HM;EACE,yBAAA;AA3HR;AA8HM;EACE,yBAAA;AA5HR;AAgIQ;EACE,mBAAA;EACA,yBAAA;EACA,kDAAA;AA9HV;AAiIQ;EACE,cAAA;AA/HV;AAkIQ;EACE,yBAAA;AAhIV;AAkIU;EACE,cAAA;AAhIZ;AAuII;EACE,gCAAA;AArIN;AAuIM;EACE,yBAAA;AArIR;AAuIQ;EACE,yBAAA;AArIV;AAwIQ;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAtIV;AA6IM;EACE,mBAAA;EACA,yBAAA;EACA,4CAAA;AA3IR;AA6IQ;EACE,sCAAA;EACA,8CAAA;AA3IV;AA8IQ;EACE,uBAAA;AA5IV;AA8IU;EACE,yBAAA;AA5IZ;AAgJQ;EACE,cAAA;AA9IV;AAiJQ;EACE,cAAA;AA/IV;AAkJQ;EACE,cAAA;AAhJV;AAmJQ;EACE,yBAAA;EACA,6BAAA;AAjJV;AAmJU;EACE,yBAAA;AAjJZ;AAwJI;EACE,uDAAA;EACA,qDAAA;AAtJN;AAwJM;EACE,cAAA;AAtJR;AAyJM;EACE,gCAAA;AAvJR;AA0JM;EACE,mBAAA;EACA,cAAA;AAxJR;AA0JQ;EACE,mBAAA;AAxJV;AA+JM;EACE,mBAAA;EACA,yBAAA;EACA,4CAAA;AA7JR;AA+JQ;EACE,qBAAA;EACA,+CAAA;AA7JV;AAgKQ;EACE,oCAAA;AA9JV;AAiKQ;EACE,yBAAA;AA/JV;AAkKQ;EACE,yBAAA;AAhKV;AAsKI;EACE,mBAAA;EACA,cAAA;EACA,6BAAA;AApKN;AAsKM;;EAEE,yBAAA;AApKR;AAuKM;EACE,yBAAA;AArKR;AAuKQ;EACE,yBAAA;AArKV;AAyKM;EACE,0CAAA;AAvKR;AA0KM;EACE,yBAAA;AAxKR;AA0KQ;EACE,yBAAA;AAxKV;AA4KM;EACE,yBAAA;AA1KR;AA6KM;EACE,yBAAA;AA3KR;AA8KM;EACE,yBAAA;AA5KR;AA8KQ;EACE,yBAAA;AA5KV;AAkLI;EACE,mBAAA;AAhLN;AAmLI;EACE,mBAAA;EACA,cAAA;AAjLN;AAoLI;EACE,yBAAA;AAlLN;;AAwLA;EACE;;;;IAIE,yBAAA;IACA,8BAAA;EArLF;AACF","sourcesContent":[".faq-support-page {\n  margin-top: 0 !important;\n  \n  .main-container {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n  }\n\n  .header-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  .theme-toggle-button {\n    border-radius: 999px;\n    padding: 2px;\n    background: transparent;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    cursor: pointer;\n\n    &:focus,\n    &:active,\n    &:focus-visible {\n      border: none;\n      outline: none;\n      box-shadow: none;\n    }\n\n    &:hover {\n      background: transparent;\n    }\n  }\n\n  .theme-toggle-track {\n    width: 48px;\n    height: 26px;\n    border-radius: 999px;\n    background: #e5e7eb;\n    border: none;\n    display: inline-flex;\n    align-items: center;\n    padding: 1px;\n    transition: background-color 0.2s ease;\n  }\n\n  .theme-toggle-track.active {\n    background: #1f2937;\n  }\n\n  .theme-toggle-thumb {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: #ffffff;\n    color: #6b7280;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transform: translateX(0);\n    transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n  }\n\n  .theme-toggle-track.active .theme-toggle-thumb {\n    transform: translateX(22px);\n    color: #ffffff;\n    background: #0f172a;\n  }\n\n  .theme-toggle-thumb mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  .theme-toggle-track.active .theme-toggle-thumb mat-icon {\n    color: #ffffff !important;\n  }\n\n  .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n    color: #6b7280 !important;\n  }\n\n  // Page Header\n  .page-header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    width: 100%;\n    margin-top: 0 !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(10, 12, 16, 0.95);\n    backdrop-filter: blur(20px);\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n\n    // Ensure sidebar appears above page header when open\n    ~ :global(.flow-sidebar) {\n      z-index: 1001 !important;\n    }\n\n    &.scrolled {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n      background: rgba(10, 12, 16, 0.98);\n    }\n\n    .header-container {\n      max-width: 100%;\n      width: 100%;\n      padding: 0 16px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n\n      @media (max-width: 768px) {\n        padding: 0 16px;\n        gap: 16px;\n        height: 56px;\n      }\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-shrink: 0;\n      margin-right: 0;\n    }\n\n    .menu-button {\n      background: none;\n      border: none;\n      color: #ffffff;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.2s;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .header-logo {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      img {\n        height: 45px;\n        width: auto;\n        display: block;\n      }\n    }\n\n    .header-nav {\n      display: flex;\n      align-items: center;\n      gap: 40px;\n      flex: 1;\n      justify-content: center;\n      min-width: 0;\n      margin: 0 auto;\n\n      @media (max-width: 1024px) {\n        gap: 24px;\n      }\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .nav-link {\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.15em;\n        color: rgba(255, 255, 255, 0.5);\n        text-decoration: none;\n        transition: color 0.3s ease;\n        cursor: pointer;\n        white-space: nowrap;\n        padding: 4px 0;\n\n        &:hover {\n          color: #ffffff;\n        }\n      }\n    }\n\n    .btn-get-started {\n      background: #ffffff;\n      color: #000000;\n      padding: 10px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 700;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      white-space: nowrap;\n      flex-shrink: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      margin-left: 0;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.95);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      @media (max-width: 768px) {\n        padding: 8px 16px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  // Breadcrumb adjustment for header\n  .breadcrumb {\n    margin-top: 64px;\n    \n    @media (max-width: 768px) {\n      margin-top: 56px;\n    }\n  }\n\n  // Main FAQ Page Styles\n  font-family: \"Open Sans\", sans-serif !important;\n  background: #101922;\n  color: #ffffff;\n  min-height: 100vh;\n  \n  .main-container {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n  }\n\n  // Page Header\n  .page-header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    width: 100%;\n    margin-top: 0 !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(10, 12, 16, 0.95);\n    backdrop-filter: blur(20px);\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n\n    // Ensure sidebar appears above page header when open\n    ~ :global(.flow-sidebar) {\n      z-index: 1001 !important;\n    }\n\n    &.scrolled {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n      background: rgba(10, 12, 16, 0.98);\n    }\n\n    .header-container {\n      max-width: 100%;\n      width: 100%;\n      padding: 0 16px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n\n      @media (max-width: 768px) {\n        padding: 0 16px;\n        gap: 16px;\n        height: 56px;\n      }\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-shrink: 0;\n      margin-right: 0;\n    }\n\n    .menu-button {\n      background: none;\n      border: none;\n      color: #ffffff;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.2s;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .header-logo {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      img {\n        height: 45px;\n        width: auto;\n        display: block;\n      }\n    }\n\n    .header-nav {\n      display: flex;\n      align-items: center;\n      gap: 40px;\n      flex: 1;\n      justify-content: center;\n      min-width: 0;\n      margin: 0 auto;\n\n      @media (max-width: 1024px) {\n        gap: 24px;\n      }\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .nav-link {\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.15em;\n        color: rgba(255, 255, 255, 0.5);\n        text-decoration: none;\n        transition: color 0.3s ease;\n        cursor: pointer;\n        white-space: nowrap;\n        padding: 4px 0;\n\n        &:hover {\n          color: #ffffff;\n        }\n      }\n    }\n\n    .btn-get-started {\n      background: #ffffff;\n      color: #000000;\n      padding: 10px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 700;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      white-space: nowrap;\n      flex-shrink: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      margin-left: 0;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.95);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      @media (max-width: 768px) {\n        padding: 8px 16px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  // Breadcrumb adjustment for header\n  .breadcrumb {\n    margin-top: 64px;\n    padding-top: 16px;\n    \n    @media (max-width: 768px) {\n      margin-top: 56px;\n    }\n  }\n\n  // Breadcrumb\n  .breadcrumb {\n    max-width: 960px;\n    margin: 0 auto;\n    padding: 8px 0;\n    font-size: 14px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    background: transparent;\n\n    a {\n      color: #ffffff !important;\n      text-decoration: none;\n      font-weight: 500;\n      transition: color 0.3s ease;\n\n      &:hover {\n        color: #5ea1d8 !important;\n      }\n    }\n\n    span:last-child {\n      color: #ffffff !important;\n      font-weight: 600;\n    }\n\n    .separator {\n      color: #94a3b8;\n      font-weight: 500;\n    }\n\n    @media (max-width: 768px) {\n      padding: 8px 16px;\n      font-size: 13px;\n    }\n  }\n\n  // Main Container\n  .faq-container {\n    max-width: 960px;\n    margin: 0 auto;\n    padding: 40px 16px 80px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (max-width: 768px) {\n      padding: 20px 16px 60px;\n      gap: 20px;\n    }\n  }\n\n  // Header Section\n  .faq-header {\n    text-align: center;\n    margin-bottom: 0;\n    padding: 40px 0 60px;\n    background: linear-gradient(to bottom, transparent, rgba(94, 161, 216, 0.05));\n    border-radius: 12px;\n    border: 1px solid rgba(94, 161, 216, 0.1);\n    margin-bottom: 0;\n    position: relative;\n    z-index: 1;\n\n    @media (max-width: 768px) {\n      padding: 30px 16px 50px;\n      margin-bottom: 0;\n    }\n\n    .faq-title {\n      font-size: 48px;\n      font-weight: 700;\n      margin-bottom: 16px;\n      color: #ffffff !important;\n      letter-spacing: -0.025em;\n      font-family: \"Open Sans\", sans-serif;\n      padding: 0 16px;\n      line-height: 1.25;\n\n      @media (max-width: 768px) {\n        font-size: 36px;\n        margin-bottom: 12px;\n      }\n    }\n\n    .faq-subtitle {\n      font-size: 18px;\n      color: #ffffff !important;\n      margin-bottom: 0;\n      line-height: 1.6;\n      max-width: 672px;\n      display: inline-block;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 0 24px;\n\n      @media (max-width: 768px) {\n        font-size: 16px;\n        padding: 0 20px;\n      }\n    }\n\n    // Search Container\n    .search-container {\n      position: absolute;\n      bottom: -28px;\n      left: 50%;\n      transform: translateX(-50%);\n      max-width: 672px;\n      width: calc(100% - 32px);\n      margin: 0 auto;\n      z-index: 2;\n      padding: 0 16px;\n\n      .search-wrapper {\n        background: #1c2631;\n        border-radius: 12px;\n        border: 1px solid #334155;\n        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n        padding: 4px;\n      }\n\n      .search-label {\n        display: flex;\n        align-items: center;\n        height: 56px;\n        width: 100%;\n        cursor: text;\n      }\n\n      .search-icon-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding-left: 20px;\n        color: #94a3b8;\n      }\n\n      .search-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n        pointer-events: none;\n      }\n\n      .search-input {\n        flex: 1;\n        min-width: 0;\n        padding: 0;\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        color: #ffffff !important;\n        font-size: 18px;\n        font-weight: 400;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding-left: 16px;\n        padding-right: 16px;\n\n        &::placeholder {\n          color: #94a3b8;\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n\n  // Category Tabs\n  .category-tabs {\n    display: flex;\n    justify-content: center;\n    gap: 32px;\n    margin-top: 32px;\n    flex-wrap: wrap;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 0 16px;\n    overflow-x: auto;\n\n    @media (max-width: 768px) {\n      gap: 20px;\n      justify-content: flex-start;\n      -webkit-overflow-scrolling: touch;\n      scrollbar-width: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    .category-tab {\n      background: transparent;\n      border: none;\n      outline: none;\n      box-shadow: none;\n      color: #ffffff !important;\n      font-size: 16px;\n      font-weight: 700;\n      padding: 16px 8px 13px;\n      cursor: pointer;\n      transition: color 0.3s ease;\n      font-family: \"Open Sans\", sans-serif;\n      position: relative;\n      white-space: nowrap;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      letter-spacing: 0.025em;\n      line-height: 1.5;\n      -webkit-tap-highlight-color: transparent;\n\n      @media (max-width: 768px) {\n        font-size: 16px;\n        padding: 16px 8px 13px;\n      }\n\n      &:hover {\n        color: #5ea1d8 !important;\n      }\n\n      &:focus,\n      &:active,\n      &:focus-visible {\n        border: none;\n        outline: none;\n        box-shadow: none;\n      }\n\n      &.active {\n        color: #5ea1d8 !important;\n        border: none;\n        outline: none;\n        box-shadow: none;\n        background: transparent;\n      }\n    }\n  }\n\n  // FAQ Accordion\n  .faq-accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 24px;\n\n    .faq-item {\n      background: #1c2631;\n      border: 1px solid #334155;\n      border-radius: 12px;\n      overflow: hidden;\n      transition: all 0.3s ease;\n\n      &:hover {\n        border-color: rgba(94, 161, 216, 0.5);\n      }\n\n      .faq-question {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 24px;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        width: 100%;\n        text-align: left;\n        background: transparent;\n        border: none;\n\n        @media (max-width: 768px) {\n          padding: 20px;\n        }\n\n        .faq-question-text {\n          font-size: 18px;\n          font-weight: 600;\n          color: #ffffff !important;\n          flex: 1;\n          text-align: left;\n          line-height: 1.5;\n\n          @media (max-width: 768px) {\n            font-size: 16px;\n          }\n        }\n\n        .faq-icon {\n          font-size: 24px;\n          width: 24px;\n          height: 24px;\n          transition: all 0.3s ease;\n          flex-shrink: 0;\n          margin-left: 16px;\n        }\n      }\n\n      &.open {\n        .faq-icon {\n          color: #5ea1d8;\n        }\n      }\n\n      &:not(.open) {\n        .faq-icon {\n          color: #94a3b8;\n        }\n\n        &:hover .faq-icon {\n          color: #5ea1d8;\n        }\n      }\n\n      .faq-answer {\n        padding: 0 24px 24px;\n        color: #ffffff !important;\n        font-size: 18px;\n        line-height: 1.75;\n        animation: fadeIn 0.3s ease;\n        border-top: 1px solid #1e293b;\n        padding-top: 16px;\n        margin-top: 0;\n        text-align: left;\n\n        @media (max-width: 768px) {\n          padding: 0 20px 20px;\n          padding-top: 16px;\n          font-size: 17px;\n        }\n\n        p {\n          margin: 0;\n          color: #ffffff !important;\n          font-size: 18px;\n          text-align: left;\n\n          @media (max-width: 768px) {\n            font-size: 17px;\n          }\n        }\n      }\n    }\n  }\n\n  // Support CTA\n  .support-cta {\n    background: linear-gradient(to right, #5ea1d8, #5ea1d8);\n    border-radius: 16px;\n    padding: 32px;\n    margin-top: 48px;\n    margin-bottom: 40px;\n    box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.2);\n\n    @media (max-width: 768px) {\n      padding: 24px;\n      margin-top: 40px;\n    }\n\n    .cta-content {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      max-width: 100%;\n      gap: 24px;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        gap: 24px;\n        align-items: flex-start;\n      }\n\n      .cta-text-section {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        .cta-heading {\n          font-size: 24px;\n          font-weight: 700;\n          color: #ffffff;\n          margin: 0;\n          font-family: \"Open Sans\", sans-serif;\n\n          @media (max-width: 768px) {\n            font-size: 20px;\n          }\n        }\n\n        .cta-text {\n          font-size: 16px;\n          color: rgba(191, 219, 254, 0.9);\n          margin: 0;\n          line-height: 1.5;\n\n          @media (max-width: 768px) {\n            font-size: 15px;\n          }\n        }\n      }\n\n      .cta-button {\n        background: #ffffff;\n        color: #5ea1d8;\n        border: none;\n        padding: 12px 32px;\n        border-radius: 12px;\n        font-size: 14px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        font-family: \"Open Sans\", sans-serif;\n        white-space: nowrap;\n\n        @media (max-width: 768px) {\n          width: 100%;\n          max-width: none;\n        }\n\n        &:hover {\n          background: #eff6ff;\n        }\n      }\n    }\n  }\n\n  // Resources Section\n  .resources-section {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-bottom: 64px;\n\n    @media (max-width: 968px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      gap: 20px;\n    }\n\n    .resource-card {\n      background: rgba(15, 23, 42, 0.5);\n      border: 1px solid transparent;\n      border-radius: 12px;\n      padding: 24px;\n      text-align: left;\n      transition: all 0.3s ease;\n      cursor: pointer;\n\n      @media (max-width: 768px) {\n        padding: 20px;\n      }\n\n      &:hover {\n        border-color: #334155;\n      }\n\n      .resource-icon {\n        width: 40px;\n        height: 40px;\n        margin-bottom: 16px;\n        background: rgba(94, 161, 216, 0.2);\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        mat-icon {\n          color: #5ea1d8;\n          font-size: 24px;\n          width: 24px;\n          height: 24px;\n        }\n      }\n\n      .resource-title {\n        font-size: 16px;\n        font-weight: 700;\n        color: #ffffff !important;\n        margin-bottom: 8px;\n        font-family: \"Open Sans\", sans-serif;\n\n        @media (max-width: 768px) {\n          font-size: 15px;\n        }\n      }\n\n      .resource-description {\n        font-size: 14px;\n        color: #ffffff !important;\n        line-height: 1.5;\n        margin: 0;\n\n        @media (max-width: 768px) {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n\n  // Footer\n  // Footer\n  .footer {\n    background: #000000;\n    color: #ffffff;\n    padding: 14px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n\n    .copy-rights {\n      max-width: 1400px;\n      margin: 0 auto;\n      padding: 0 24px;\n      width: 100%;\n\n      .row {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        width: 100%;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 16px;\n        }\n      }\n\n      .col-md-5,\n      .col-md-7,\n      .col-12 {\n        padding: 0;\n        display: flex;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          width: 100%;\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-5 {\n        @media (min-width: 769px) {\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-7 {\n        @media (min-width: 769px) {\n          justify-content: flex-end;\n        }\n      }\n    }\n\n    .cpyrgt {\n      color: #64748b !important;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      font-size: 14px;\n      line-height: 1.5;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n      }\n\n      li {\n        color: #64748b !important;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n\n        a {\n          color: #64748b !important;\n          text-decoration: none;\n          margin-left: 4px;\n\n          &:hover {\n            color: #5ea1d8 !important;\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .f-menu-right {\n      display: flex;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      align-items: center;\n      justify-content: flex-end;\n      flex-wrap: wrap;\n      gap: 0;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        justify-content: flex-start;\n        flex-wrap: wrap;\n      }\n\n      li {\n        padding: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n\n        &:not(:last-child)::after {\n          content: '|';\n          color: rgba(100, 116, 139, 0.5);\n          margin: 0 12px;\n          font-size: 14px;\n        }\n\n        a {\n          color: #64748b !important;\n          font-size: 14px;\n          text-decoration: none;\n          transition: color 0.3s ease;\n          padding: 4px 0;\n          white-space: nowrap;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    h6 {\n      color: #94a3b8 !important;\n      font-weight: 700 !important;\n      font-size: 12px !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.1em !important;\n      margin-bottom: 16px !important;\n    }\n\n    ul {\n      li {\n        a {\n          color: #64748b !important;\n          font-size: 14px !important;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    p {\n      color: #475569 !important;\n      font-size: 14px !important;\n    }\n\n    .material-symbols-outlined {\n      color: #475569 !important;\n\n      &:hover {\n        color: #ffffff !important;\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ─── Light Mode ──────────────────────────────────────────────────────────────\n// NOTE ON SPECIFICITY: Dark styles are deeply nested inside .faq-support-page,\n// giving them high specificity (e.g. 0,6,0). Each override below mirrors the\n// full nesting path so it wins the !important specificity battle.\n\n// ── Page root ─────────────────────────────────────────────────────────────────\n:host-context(body.theme-light) .faq-support-page {\n  background: #f8fafc !important;\n  color: #1e293b !important;\n}\n\n// ── Header ────────────────────────────────────────────────────────────────────\n// background, border, shadow – no !important in dark styles, flat override wins\n:host-context(body.theme-light) .faq-support-page .page-header {\n  background: rgba(255, 255, 255, 0.97) !important;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.09) !important;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08) !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header.scrolled {\n  background: rgba(255, 255, 255, 1) !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header .menu-button {\n  color: #1e293b !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header .menu-button:hover {\n  background-color: rgba(15, 23, 42, 0.07) !important;\n}\n// nav-link: dark has rgba(255,255,255,0.5) without !important – !important override wins\n:host-context(body.theme-light) .faq-support-page .page-header .header-nav .nav-link {\n  color: #475569 !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header .header-nav .nav-link:hover {\n  color: #1e293b !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header .btn-get-started {\n  background: #5ea1d8 !important;\n  color: #ffffff !important;\n}\n:host-context(body.theme-light) .faq-support-page .page-header .btn-get-started:hover {\n  background: #3b8ec7 !important;\n}\n\n// ── Breadcrumb ────────────────────────────────────────────────────────────────\n// dark: .faq-support-page .breadcrumb a { color: #fff !important } → spec 031+1elem = 041\n// override path adds body+.theme-light → spec 051+1elem wins\n:host-context(body.theme-light) .faq-support-page .breadcrumb a {\n  color: #334155 !important;\n}\n:host-context(body.theme-light) .faq-support-page .breadcrumb a:hover {\n  color: #5ea1d8 !important;\n}\n:host-context(body.theme-light) .faq-support-page .breadcrumb span:last-child {\n  color: #0f172a !important;\n}\n\n// ── Hero / FAQ header ─────────────────────────────────────────────────────────\n// Slightly darker Flowchest blue gradient so the hero section stands out\n:host-context(body.theme-light) .faq-support-page .faq-header {\n  background: linear-gradient(135deg, #1a5f94 0%, #2472a4 40%, #3b8ec7 100%) !important;\n  border: none !important;\n  box-shadow: 0 4px 24px rgba(26, 95, 148, 0.25) !important;\n}\n// Text stays white — it's on a deep blue background\n:host-context(body.theme-light) .faq-support-page .faq-header .faq-title {\n  color: #ffffff !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-header .faq-subtitle {\n  color: rgba(255, 255, 255, 0.88) !important;\n}\n\n// ── Search ────────────────────────────────────────────────────────────────────\n// dark: .faq-support-page .faq-header .search-container .search-input { color: #fff !important } → spec 050\n// override: body.theme-light + full path → spec 061, wins\n:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-wrapper {\n  background: #ffffff !important;\n  border: 1px solid rgba(255, 255, 255, 0.6) !important;\n  box-shadow: 0 12px 32px rgba(26, 95, 148, 0.3) !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-icon-wrapper {\n  color: #2472a4 !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-input {\n  color: #0f172a !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-header .search-container .search-input::placeholder {\n  color: #94a3b8 !important;\n}\n\n// ── Category tabs ─────────────────────────────────────────────────────────────\n// dark: .faq-support-page .category-tabs .category-tab { color: #fff !important } → spec 040\n// override: body.theme-light + full path → spec 051, wins\n:host-context(body.theme-light) .faq-support-page .category-tabs {\n  border-bottom: 1px solid #cbd5e1 !important;\n}\n:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab {\n  color: #64748b !important;\n}\n:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab:hover {\n  color: #5ea1d8 !important;\n}\n:host-context(body.theme-light) .faq-support-page .category-tabs .category-tab.active {\n  color: #5ea1d8 !important;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n// ── FAQ accordion ─────────────────────────────────────────────────────────────\n// dark: .faq-question-text { color: #fff !important } nesting depth 5 → spec 060\n// dark: .faq-answer { color: #fff !important } depth 4 → spec 050\n// dark: .faq-answer p { color: #fff !important } depth 4 + p element → spec 051\n// Each override adds body+.theme-light to outspec\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item {\n  background: #ffffff !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05) !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item:hover {\n  border-color: rgba(94, 161, 216, 0.45) !important;\n  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.1) !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-question .faq-question-text {\n  color: #1e293b !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item:not(.open) .faq-icon {\n  color: #5ea1d8 !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item.open .faq-icon {\n  color: #5ea1d8 !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-answer {\n  color: #334155 !important;\n  border-top: 1px solid #f1f5f9 !important;\n}\n:host-context(body.theme-light) .faq-support-page .faq-accordion .faq-item .faq-answer p {\n  color: #334155 !important;\n}\n\n// ── Support CTA ───────────────────────────────────────────────────────────────\n:host-context(body.theme-light) .faq-support-page .support-cta {\n  background: linear-gradient(to right, #5ea1d8, #3b8ec7) !important;\n  box-shadow: 0 16px 32px -8px rgba(94, 161, 216, 0.3) !important;\n}\n:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-text-section .cta-heading {\n  color: #ffffff !important;\n}\n:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-text-section .cta-text {\n  color: rgba(219, 234, 254, 0.95) !important;\n}\n:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-button {\n  background: #ffffff !important;\n  color: #5ea1d8 !important;\n}\n:host-context(body.theme-light) .faq-support-page .support-cta .cta-content .cta-button:hover {\n  background: #eff6ff !important;\n}\n\n// ── Resource cards ────────────────────────────────────────────────────────────\n// dark: .resource-title { color: #fff !important } depth 4 → spec 050\n// override: body.theme-light + full path → spec 061, wins\n:host-context(body.theme-light) .faq-support-page .resources-section .resource-card {\n  background: #ffffff !important;\n  border: 1px solid #e2e8f0 !important;\n}\n:host-context(body.theme-light) .faq-support-page .resources-section .resource-card:hover {\n  border-color: #5ea1d8 !important;\n  box-shadow: 0 4px 16px rgba(94, 161, 216, 0.15) !important;\n}\n:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-icon {\n  background: rgba(94, 161, 216, 0.12) !important;\n}\n:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-title {\n  color: #0f172a !important;\n}\n:host-context(body.theme-light) .faq-support-page .resources-section .resource-card .resource-description {\n  color: #64748b !important;\n}\n\n// ── Footer ────────────────────────────────────────────────────────────────────\n:host-context(body.theme-light) .faq-support-page .footer {\n  background: #f1f5f9 !important;\n  color: #475569 !important;\n  border-top: 1px solid #e2e8f0 !important;\n}\n:host-context(body.theme-light) .faq-support-page .footer .cpyrgt,\n:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li {\n  color: #64748b !important;\n}\n:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li a,\n:host-context(body.theme-light) .faq-support-page .footer .f-menu-right li a {\n  color: #64748b !important;\n}\n:host-context(body.theme-light) .faq-support-page .footer .cpyrgt li a:hover,\n:host-context(body.theme-light) .faq-support-page .footer .f-menu-right li a:hover {\n  color: #5ea1d8 !important;\n}\n\n// ── Theme toggle ──────────────────────────────────────────────────────────────\n:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) {\n  background: #e5e7eb !important;\n}\n:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb {\n  background: #ffffff !important;\n}\n:host-context(body.theme-light) .faq-support-page .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n  color: #5ea1d8 !important;\n}\n\n// ── disabled block kept below for reference (uses body.theme-light-DISABLED)\nbody.theme-light-DISABLED {\n  .faq-support-page {\n    background: #f8fafc;\n    color: #0f172a;\n\n    // ── Header ──────────────────────────────────────────────────────────────\n    .page-header {\n      background: rgba(255, 255, 255, 0.97);\n      border-bottom: 1px solid rgba(15, 23, 42, 0.09);\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n\n      &.scrolled {\n        background: rgba(255, 255, 255, 1);\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n      }\n\n      .menu-button {\n        color: #1e293b;\n\n        &:hover {\n          background-color: rgba(15, 23, 42, 0.07);\n        }\n      }\n\n      .header-nav .nav-link {\n        color: rgba(15, 23, 42, 0.5);\n\n        &:hover {\n          color: #0f172a;\n        }\n      }\n\n      .btn-get-started {\n        background: #0f172a;\n        color: #ffffff;\n        box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);\n\n        &:hover {\n          background: #1e293b;\n          box-shadow: 0 4px 10px rgba(15, 23, 42, 0.22);\n        }\n      }\n    }\n\n    // ── Breadcrumb ───────────────────────────────────────────────────────────\n    .breadcrumb {\n      a {\n        color: #334155 !important;\n\n        &:hover {\n          color: #5ea1d8 !important;\n        }\n      }\n\n      span:last-child {\n        color: #0f172a !important;\n      }\n\n      .separator {\n        color: #94a3b8;\n      }\n    }\n\n    // ── Hero / FAQ header section ─────────────────────────────────────────────\n    .faq-header {\n      background: linear-gradient(to bottom, #eef5fb, rgba(219, 234, 254, 0.35));\n      border: 1px solid rgba(94, 161, 216, 0.2);\n\n      .faq-title {\n        color: #0f172a !important;\n      }\n\n      .faq-subtitle {\n        color: #475569 !important;\n      }\n\n      .search-container {\n        .search-wrapper {\n          background: #ffffff;\n          border: 1px solid #cbd5e1;\n          box-shadow: 0 8px 24px -6px rgba(15, 23, 42, 0.12);\n        }\n\n        .search-icon-wrapper {\n          color: #64748b;\n        }\n\n        .search-input {\n          color: #0f172a !important;\n\n          &::placeholder {\n            color: #94a3b8;\n          }\n        }\n      }\n    }\n\n    // ── Category tabs ─────────────────────────────────────────────────────────\n    .category-tabs {\n      border-bottom: 1px solid #cbd5e1;\n\n      .category-tab {\n        color: #64748b !important;\n\n        &:hover {\n          color: #1e293b !important;\n        }\n\n        &.active {\n          color: #5ea1d8 !important;\n          border: none;\n          outline: none;\n          box-shadow: none;\n          background: transparent;\n        }\n      }\n    }\n\n    // ── FAQ accordion ─────────────────────────────────────────────────────────\n    .faq-accordion {\n      .faq-item {\n        background: #ffffff;\n        border: 1px solid #e2e8f0;\n        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n\n        &:hover {\n          border-color: rgba(94, 161, 216, 0.45);\n          box-shadow: 0 4px 12px rgba(94, 161, 216, 0.1);\n        }\n\n        .faq-question {\n          background: transparent;\n\n          .faq-question-text {\n            color: #0f172a !important;\n          }\n        }\n\n        &:not(.open) .faq-icon {\n          color: #94a3b8;\n        }\n\n        &:not(.open):hover .faq-icon {\n          color: #5ea1d8;\n        }\n\n        &.open .faq-icon {\n          color: #5ea1d8;\n        }\n\n        .faq-answer {\n          color: #475569 !important;\n          border-top: 1px solid #f1f5f9;\n\n          p {\n            color: #475569 !important;\n          }\n        }\n      }\n    }\n\n    // ── Support CTA (brand blue – no bg change needed, tweak shadow) ──────────\n    .support-cta {\n      background: linear-gradient(to right, #5ea1d8, #3b8ec7);\n      box-shadow: 0 16px 32px -8px rgba(94, 161, 216, 0.35);\n\n      .cta-heading {\n        color: #ffffff;\n      }\n\n      .cta-text {\n        color: rgba(219, 234, 254, 0.95);\n      }\n\n      .cta-button {\n        background: #ffffff;\n        color: #5ea1d8;\n\n        &:hover {\n          background: #eff6ff;\n        }\n      }\n    }\n\n    // ── Resources cards ───────────────────────────────────────────────────────\n    .resources-section {\n      .resource-card {\n        background: #ffffff;\n        border: 1px solid #e2e8f0;\n        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);\n\n        &:hover {\n          border-color: #bfdbfe;\n          box-shadow: 0 4px 16px rgba(94, 161, 216, 0.12);\n        }\n\n        .resource-icon {\n          background: rgba(94, 161, 216, 0.12);\n        }\n\n        .resource-title {\n          color: #0f172a !important;\n        }\n\n        .resource-description {\n          color: #64748b !important;\n        }\n      }\n    }\n\n    // ── Footer ────────────────────────────────────────────────────────────────\n    .footer {\n      background: #f1f5f9;\n      color: #475569;\n      border-top: 1px solid #e2e8f0;\n\n      .cpyrgt,\n      .cpyrgt li {\n        color: #64748b !important;\n      }\n\n      .cpyrgt li a {\n        color: #64748b !important;\n\n        &:hover {\n          color: #5ea1d8 !important;\n        }\n      }\n\n      .f-menu-right li::after {\n        color: rgba(100, 116, 139, 0.4) !important;\n      }\n\n      .f-menu-right li a {\n        color: #64748b !important;\n\n        &:hover {\n          color: #5ea1d8 !important;\n        }\n      }\n\n      h6 {\n        color: #64748b !important;\n      }\n\n      p {\n        color: #64748b !important;\n      }\n\n      .material-symbols-outlined {\n        color: #64748b !important;\n\n        &:hover {\n          color: #5ea1d8 !important;\n        }\n      }\n    }\n\n    // ── Theme toggle ──────────────────────────────────────────────────────────\n    .theme-toggle-track {\n      background: #e5e7eb;\n    }\n\n    .theme-toggle-track:not(.active) .theme-toggle-thumb {\n      background: #ffffff;\n      color: #6b7280;\n    }\n\n    .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n      color: #6b7280 !important;\n    }\n  }\n}\n\n// Override global mobile footer hiding for FAQ page\n@media screen and (max-width: 992px) {\n  :host footer,\n  :host .footer,\n  app-faq-support-page footer,\n  app-faq-support-page .footer {\n    display: block !important;\n    visibility: visible !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
